import React, { Fragment, useState } from "react";
import { FaCheck, FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { TD } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import { BiCloudDownload, BiDownload } from "react-icons/bi";
import { RiCloseLine } from "react-icons/ri";
import getFormattedDate, { formatDate } from "utils/helpers";

const ViewList = ({
  data,
  index,
  approveRequest,
  getData,
  page,
  approvedData,
  setApprovedData = ()=>{},
  setRejectedData = ()=>{},
  setModalData,
  setModalType,
  setShowInvoiceCost
}) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  console.log('data--', data);

  return (
    <Fragment>
      <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"}`}>

        <TD className="text-center">{(page - 1) * 20 + index + 1}</TD>
        <TD className="text-center">{data?.requestNo}</TD>
        <TD className="text-center">{data?.fleetName}</TD>
        <TD className="text-center">{data?.hubName}</TD>
        <TD className=" text-green-500 hover:text-green-600 cursor-pointer text-center font-semibold"
          onClick={() => {

            console.log(data);
            setModalType("tyres");
            setApprovedData(data);
            setRejectedData(data);
            setModalData(data);
          }}
        >{data.numberOfTyres}</TD>
        <TD className="text-center">{data.requestBy}</TD>
        <TD className="text-center">{data.requestDate}</TD>
        <TD className="text-center">{data?.vendorName}</TD>
        <TD className="text-center">{data?.status}</TD>
        <TD className="underline text-gray-500 hover:text-green-600 cursor-pointer text-center font-semibold"
          onClick={() => {
            setShowInvoiceCost({
              billNumber: data?.billInfo?.number,
              billDate: getFormattedDate(data?.billInfo?.date, '/'),
              receivedDate:getFormattedDate(data?.billInfo?.receivedDate,'/'),
              billUploadedBy: data?.billInfo?.uploadedBy,
              billAmount: data?.billInfo?.amount,
              billLink: data?.billInfo?.link,
            });
          }}
        >{data?.billInfo?.amount}</TD>
        <TD className="flex flex-row gap-1">

          {data.status === "Requested" && checkPermission([permissions.approve_retread_request], currentUser)
            ? (

              <div className="flex flex-row w-full justify-start mx-auto">

                <button
                  className="p-1 px-2 my-1 bg-green-500 hover:bg-green-600 shadow-none font-bold rounded-md text-white text-md text-center"
                  onClick={() => {
                    setModalType("approval");
                    setApprovedData(data);
                  }}
                >
                  <FaCheck />
                </button>

                {/* <button
                className="p-1 px-2 m-1 bg-red-500 hover:bg-red-600 shadow-none font-bold rounded-md text-white text-lg"
                onClick={() => {
                  setModalType("reject");
                  setRejectedData(data);
                }}
              >
                <RiCloseLine />
              </button> */}

              </div>


            )
            :
            <>---</>
          }

        </TD>

      </tr>
    </Fragment>
  );
};

export default ViewList;